import axios from 'axios'
import { ConfigurationParameterGroupResponse, ConfigurationParameterPatchInBatchRequest, ConfigurationParameterResponse } from '@/modules/configurationModule/detail/parameters/services/configuration-parameters.dto'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

export default class ConfigurationParametersLocalService {
    async getConfigurationParametersGroup(laboratoryId: number): Promise<ConfigurationParameterGroupResponse[]> {
        const response = await axios.get<ConfigurationParameterGroupResponse[]>(`/configuration/parameters/groups/laboratories/${laboratoryId}`)
        return response.data
    }

    async getConfigurationParameters(laboratoryId: number, groupId: number): Promise<ConfigurationParameterResponse[]> {
        const response = await axios.get<ConfigurationParameterResponse[]>(`/configuration/laboratories/${laboratoryId}/parameters/groups/${groupId}`)
        return response.data
    }

    async patchConfigurationParametersBatch(laboratoryId: number, request: ConfigurationParameterPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/parameters/batch`, request)
        return response.data
    }
}

export const configurationParametersLocalService = new ConfigurationParametersLocalService()
